import { render, staticRenderFns } from "./summary-chart.vue?vue&type=template&id=1824bf3a&scoped=true&"
import script from "./summary-chart.js?vue&type=script&lang=js&"
export * from "./summary-chart.js?vue&type=script&lang=js&"
import style0 from "./summary-chart.scss?vue&type=style&index=0&id=1824bf3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1824bf3a",
  null
  
)

export default component.exports